import { getCore as get, postCore as post, delCore as del, putCore as put } from "../../../utils/httpInterceptor";

class webNewsServiceGen {

  // Legacy endpoints don't require tenant ID in the URL
  static getApiPath(endpoint) {
    return `/api/legacy/${endpoint}`;
  }

  // Build query string for pagination, sort and filter parameters
  static buildQueryString(page = 0, pageSize = 100, sort = [], filters = {}) {
    const params = new URLSearchParams();
    params.append('page', page.toString());
    params.append('size', pageSize.toString());
    
    // Spring Boot Pageable expects sort in format: sort=field,direction
    // Multiple sort criteria: sort=field1,dir1&sort=field2,dir2
    if (sort && sort.length > 0) {
      sort.forEach(sortItem => {
        if (sortItem && sortItem.field && sortItem.direction) {
          params.append('sort', `${sortItem.field},${sortItem.direction}`);
        }
      });
    }
    
    // Add filter parameters
    if (filters && typeof filters === 'object') {
      Object.entries(filters).forEach(([key, value]) => {
        if (value !== undefined && value !== null && value !== '') {
          if (Array.isArray(value)) {
            value
              .filter(item => item !== undefined && item !== null && item !== '')
              .forEach(item => params.append(key, item.toString()));
            return;
          }
          params.append(key, value.toString());
        }
      });
    }
    return params.toString();
  }

  // Build path for composite ID (multiple PK fields)
  static buildIdPath(id) {
    const getFieldCandidates = (fieldName) => {
      if (!fieldName || typeof fieldName !== 'string') {
        return [];
      }
      const lower = fieldName.toLowerCase();
      const upper = fieldName.toUpperCase();
      const firstUpper = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
      const firstLower = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
      const restLower = fieldName.length > 1
        ? fieldName.charAt(0).toLowerCase() + fieldName.slice(1).toLowerCase()
        : firstLower;
      return [...new Set([fieldName, lower, upper, firstUpper, firstLower, restLower])];
    };

    const getFieldValueLoose = (source, fieldName) => {
      if (!source || typeof source !== 'object' || !fieldName) {
        return undefined;
      }
      const candidates = getFieldCandidates(fieldName);
      for (const candidate of candidates) {
        if (Object.prototype.hasOwnProperty.call(source, candidate)) {
          const value = source[candidate];
          if (value !== undefined && value !== null && value !== '') {
            return value;
          }
        }
      }
      return undefined;
    };

    // Composite PK: id is an object with multiple fields
    if (id && typeof id === 'object') {
      const pathParts = ['dataAreaId', 'eisnewsid'];
      const path = pathParts.map(field => getFieldValueLoose(id, field) || '').join('/');
      console.log('[buildIdPath] Composite ID:', id, '-> Path:', path);
      return path;
    }
    // Fallback for string id (backward compatibility)
    console.log('[buildIdPath] Simple ID:', id);
    return id || '';
  }

  static async list(page = 0, pageSize = 100, sort = [], filters = {}) {
    const queryString = webNewsServiceGen.buildQueryString(page, pageSize, sort, filters);
    const basePath = webNewsServiceGen.getApiPath("web-news");
    return await get(`${basePath}?${queryString}`);
  }

  static async create(payload) {
    return await post(webNewsServiceGen.getApiPath("web-news"), payload);
  }

  static async update(id, payload) {
    console.log('[update] id:', id, 'payload:', payload);
    const idPath = webNewsServiceGen.buildIdPath(id);
    console.log('[update] idPath:', idPath);
    return await put(webNewsServiceGen.getApiPath("web-news") + `/${idPath}`, payload);
  }

  static async delete(id) {
    const idPath = webNewsServiceGen.buildIdPath(id);
    return await del(webNewsServiceGen.getApiPath("web-news") + `/${idPath}`);
  }

  static async getAll(page = 0, pageSize = 100, sort = [], filters = {}) {
    const data = await webNewsServiceGen.list(page, pageSize, sort, filters);

    // Handle Spring Page response: data.content contains the array, or fallback to data for backward compatibility
    const dataContent = data?.content ?? data;
    const mappedData = Array.isArray(dataContent)
      ? dataContent.map(item => {
          // For composite PK: build id object from flattened fields
          const getFieldCandidates = (fieldName) => {
            if (!fieldName || typeof fieldName !== 'string') {
              return [];
            }
            const lower = fieldName.toLowerCase();
            const upper = fieldName.toUpperCase();
            const firstUpper = fieldName.charAt(0).toUpperCase() + fieldName.slice(1);
            const firstLower = fieldName.charAt(0).toLowerCase() + fieldName.slice(1);
            const restLower = fieldName.length > 1
              ? fieldName.charAt(0).toLowerCase() + fieldName.slice(1).toLowerCase()
              : firstLower;
            return [...new Set([fieldName, lower, upper, firstUpper, firstLower, restLower])];
          };

          const getFieldValueLoose = (source, fieldName) => {
            if (!source || typeof source !== 'object' || !fieldName) {
              return undefined;
            }
            const candidates = getFieldCandidates(fieldName);
            for (const candidate of candidates) {
              if (Object.prototype.hasOwnProperty.call(source, candidate)) {
                const value = source[candidate];
                if (value !== undefined && value !== null && value !== '') {
                  return value;
                }
              }
            }
            return undefined;
          };

          const existingId = item?.id && typeof item.id === 'object' ? item.id : {};
          const idObj = {};
          idObj['dataAreaId'] = getFieldValueLoose(existingId, 'dataAreaId') ?? getFieldValueLoose(item, 'dataAreaId');
          idObj['eisnewsid'] = getFieldValueLoose(existingId, 'eisnewsid') ?? getFieldValueLoose(item, 'eisnewsid');
          return {
            ...item,
            id: idObj
          };
        })
      : [];

    return {
      content: mappedData,
      totalElements: data?.totalElements ?? mappedData.length,
      totalPages: data?.totalPages ?? 1
    };
  }

  static async getAllList(page = 0, pageSize = 100, sort = [], filters = {}) {
    const result = await webNewsServiceGen.getAll(page, pageSize, sort, filters);
    return result?.content || [];
  }
}

export default webNewsServiceGen;